import Cookie from 'cookie-universal'

import { CART_EMAIL, ONE_DAY } from '@mc/constants'

export const setCartEmailCookie = (email: string) => {
  const cookies = Cookie()

  cookies.set(CART_EMAIL, email, {
    // TODO: this is a hot fix realated to PRC-140.
    // We should migrate rails to use cookie-universal, and delete
    // This dummy encode function.
    encode: (e) => e,
    maxAge: ONE_DAY,
    path: '/',
  })
}
